/*!
 * JEDEYE Reservation Module.
 */
$(function () {

    /* Fleet Filtering */
    function refreshLocationsByFleet(fleetId, $form) {
        $('#pickupStation option, #dropoffStation option', $form).prop('disabled', true);
        $('#pickupStation option[data-fleet-id="' + fleetId + '"], #dropoffStation option[data-fleet-id="' + fleetId + '"]', $form).prop('disabled', false);

        $('#pickupStation, #dropoffStation', $form).each(function () {
            var selectedOption = $(this).select2("data");
            if (selectedOption[0].id == '' || (selectedOption[0].id != '' && $(selectedOption[0].element).data('fleet-id') != fleetId)) {
                $(this).val(null);
            }
            $(this).select2({
                minimumResultsForSearch: -1
            });
        });
    }

    function formReadyCheck($form) {
        if (
            $('#pickupStation', $form).val() != "" &&
            $('#dropoffStation', $form).val() != "" &&
            $('#pickupDatePicker', $form).val() != "" &&
            $('#dropoffDatePicker', $form).val() != "" &&
            $('#pickupTimePicker', $form).val() != "" &&
            $('#dropoffTimePicker', $form).val() != ""
        ) {
            setTimeout(function () {
                if ($form.data('auto-trigger') == '1'
                    && $form.data('auto-lock-submit') != '1') {
                    $form.find("[type=submit]").trigger('click');
                }
            }, 250);
        }
    }

    function showPickupTimepicker($form) {
        $('#pickupTimePicker', $form).prop('readonly', false);
        $('#pickupTimePicker', $form).timepicker('show');
        $('#pickupTimePicker', $form).prop('readonly', true);
    }

    function showDropoffTimepicker($form) {
        $('#dropoffTimePicker', $form).prop('readonly', false);
        $('#dropoffTimePicker', $form).timepicker('show');
        $('#dropoffTimePicker', $form).prop('readonly', true);
    }

    $('.booking-form').each(function() {
        var $targetForm = $(this);

        $('.btn-radio-group', $targetForm).each(function () {
            var $self = $(this);
            var $selectedValue = $self.find('.btn-radio-value').first();
            $self.find('.btn-radio').click(function () {
                $('.btn-radio', $self).removeClass('active');
                $selectedValue.val($(this).data('id')).trigger('change');
                $(this).addClass('active');
            });
            setTimeout(function () {
                $self.find('[data-id="' + $selectedValue.val() + '"]').trigger('click');
            }, 50);
        });

        if($targetForm.attr('data-fleet-mode') == '1') {
            $('[name="fleet"]', $targetForm).on('change', function () {
                var fleetId = $(this).val();
                refreshLocationsByFleet(fleetId, $form);
            });
        }

        /* Homepage Booking Form */
        // if($targetForm.hasClass('main') && !$targetForm.hasClass('groupReservationForm')) {
            // $targetForm.submit(function (e) {
                // e.preventDefault();
                // $(this).request('reservationComponent::onMainFormPost', {
                //     data: $targetForm.serialize(),
                //     loading: $.oc.stripeLoadIndicator,
                //     success: function (data) {
                //         this.success(data);
                //         if (data.status !== undefined && data.status == 'not_ok') {
                //             //showModalPopup(data.alert.title, data.alert.message);
                //             // Disable auto trigger in order to allow to change more than one already
                //             // filled input withou submiting automatically on the first selection
                //             $targetForm.data('auto-trigger', '0');
                //             $.oc.stripeLoadIndicator.hide(true);
                //         }
                //     },
                //     complete: function () {
                //     }
                // });
            // });
        // }else{
            if($targetForm.hasClass('groupReservationForm')) {
                $targetForm.submit(function (e) {
                    e.preventDefault();
                    $(this).request('reservationComponent::onGroupReservationFormPost', {
                        data: $(".booking-form.groupReservationForm").serialize(),
                        loading: $.oc.stripeLoadIndicator,
                        success: function (data) {
                            this.success(data);
                            if (data.status !== undefined && data.status == 'not_ok') {
                                // JedeyeUtils.showModalPopup(data.alert.title, data.alert.message);
                                // Disable auto trigger in order to allow to change more than one already
                                // filled input withou submiting automatically on the first selection
                                $('.booking-form.main').data('auto-trigger', '0');
                                $.oc.stripeLoadIndicator.hide(true);
                            }
                        },
                        complete: function () {
                        }
                    });
                });
            }
        // }

        $('#pickupStation', $targetForm).on("change", function (e) {
            if ($(this).val() == null) return;
            //pickupLocationData = $('#stationData_' + $('#pickupStation').val()).data('details')[0];
            $('#pickupDatePicker', $targetForm).prop('disabled', false);
            $('#pickupTimePicker', $targetForm).prop('disabled', false);
            formReadyCheck($targetForm);
        });

        $('#dropoffStation', $targetForm).on("change", function (e) {
            if ($(this).val() == null) return;
            //dropoffLocationData = $('#stationData_' + $('#dropoffStation').val()).data('details')[0];
            $('#dropoffDatePicker', $targetForm).prop('disabled', false);
            $('#dropoffTimePicker', $targetForm).prop('disabled', false);
            formReadyCheck($targetForm);
        });

        // Set location data when location pickers are filled when the page loads
        if ($('#pickupStation', $targetForm).val() != "")
            $('#pickupStation', $targetForm).trigger("change");

        if ($('#dropoffStation', $targetForm).val() != "")
            $('#dropoffStation', $targetForm).trigger("change");

        var pickupDatePicker = null, dropoffDatePicker = null;

        if ($('#pickupDatePicker', $targetForm).length > 0) {
            var pickupDatePickerEl = $('#pickupDatePicker', $targetForm);
            pickupDatePicker = new Pikaday({
                field: pickupDatePickerEl[0],
                firstDay: 0,
                numberOfMonths: 1,
                showDaysInNextAndPreviousMonths: true,
                minDate: new Date(),
                maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                format: $('body').data("date-format"),
                bound: true,
                yearRange: [2000, 2020],
                onSelect: function (date) {
                    // dropoffDatePicker.setMinDate(this.getDate());

                    if(dropoffDatePicker.getDate() < date) {
                        dropoffDatePicker.setDate(this.getDate());
                        dropoffDatePicker.gotoDate(this.getDate() + 1); // Change current view
                    }

                    $('#pickupDatePicker').parent().addClass('has-value');
                },
                onClose: function () {
                    if (this._o.field.value != "") { // Check if field was not left empty
                        if ($targetForm.data('auto-trigger') == '1') {
                            if ($('#pickupTimePicker', $targetForm).val() == "") {
                                $('#pickupTimePicker', $targetForm).data('force-showing', '1');
                                showPickupTimepicker($targetForm);
                            }
                        }
                        formReadyCheck($targetForm);
                    } else {
                        $targetForm.data('auto-trigger', '0');
                    }
                },
                disableDayFn: function (date) {

                    if (typeof pickupLocationData === 'undefined' || pickupLocationData == null)
                        return false;

                    // Weekdays
                    if (pickupLocationData['WeekDayOpen'] == null || pickupLocationData['WeekDayOpen'] == "") {
                        if (date.getDay() >= 1 && date.getDay() <= 5)
                            return true;
                    }

                    if (pickupLocationData['SaturDayOpen'] == null || pickupLocationData['SaturDayOpen'] == "") {
                        if (date.getDay() == 6)
                            return true;
                    }

                    if (pickupLocationData['SunDayOpen'] == null || pickupLocationData['SunDayClose'] == "") {
                        if (date.getDay() == 0)
                            return true;
                    }

                    return false;

                },
                i18n: {
                    previousMonth: 'Previous Month',
                    nextMonth: 'Next Month',
                    months: moment.months(),
                    weekdays: moment.weekdays(),
                    weekdaysShort: moment.weekdaysShort()
                }
            });
        }

        if ($('#dropoffDatePicker', $targetForm).length > 0) {
            var dropoffDatePickerEl = $('#dropoffDatePicker', $targetForm);
            dropoffDatePicker = new Pikaday({
                field: dropoffDatePickerEl[0],
                firstDay: 0,
                numberOfMonths: 1,
                showDaysInNextAndPreviousMonths: true,
                minDate: new Date(),
                maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                format: $('body').data("date-format"),
                bound: true,
                yearRange: [2000, 2020],
                onSelect: function (date) {
                    // field.value = picker.toString();
                    // pickupDatePicker.setMaxDate(this.getDate());
                    $('#dropoffDatePicker').parent().addClass('has-value');

                    if(pickupDatePicker.getDate() > date) {
                        pickupDatePicker.setDate(date);
                        pickupDatePicker.gotoDate(date - 1); // Change current view
                    }
                },
                onClose: function () {
                    if (this._o.field.value != "") { // Check if field was not left empty
                        if ($targetForm.data('auto-trigger') == '1') {
                            if ($('#dropoffTimePicker', $targetForm).val() == "") {
                                $('#dropoffTimePicker', $targetForm).data('force-showing', '1');

                                showDropoffTimepicker($targetForm);
                                //$('#dropoffTimePicker').clockpicker('show');
                            }
                        }
                        formReadyCheck($targetForm);
                    } else {
                        $targetForm.data('auto-trigger', '0');
                    }
                },
                disableDayFn: function (date) {

                    if (typeof dropoffLocationData === 'undefined' || dropoffLocationData == null)
                        return false;

                    // Weekdays
                    if (dropoffLocationData['WeekDayOpen'] == null || dropoffLocationData['WeekDayOpen'] == "") {
                        if (date.getDay() >= 1 && date.getDay() <= 5)
                            return true;
                    }

                    if (dropoffLocationData['SaturDayOpen'] == null || dropoffLocationData['SaturDayOpen'] == "") {
                        if (date.getDay() == 6)
                            return true;
                    }

                    if (dropoffLocationData['SunDayOpen'] == null || dropoffLocationData['SunDayClose'] == "") {
                        if (date.getDay() == 0)
                            return true;
                    }

                    return false;

                    //$datePicker.datebox({ blackDays : nonWorkingDays, minDays: 0 });
                },
                i18n: {
                    previousMonth: 'Previous Month',
                    nextMonth: 'Next Month',
                    months: moment.months(),
                    weekdays: moment.weekdays(),
                    weekdaysShort: moment.weekdaysShort()
                }
            });
        }

        // if ($targetForm.hasClass('main')) {
        //     if (pickupDatePicker != null && $('#dropoffTimePicker', $targetForm).val() != '') pickupDatePicker.setMaxDate(dropoffDatePicker.getDate());
        //     if (dropoffDatePicker != null && $('#pickupTimePicker', $targetForm).val() != '') dropoffDatePicker.setMinDate(pickupDatePicker.getDate());
        // }

        $('#pickupTimePicker, #dropoffTimePicker', $targetForm).each(function () {
            var $el = $(this);
            $el.timepicker({
                timeFormat: $('body').data("time-format"),
                disableTextInput: true,
                scrollDefault: "10:00",
                minTime: "0:00am",
                maxTime: "23:30pm",
                className: $el.attr('id') + "-timepicker"
            });

            $el.on('showTimepicker', function () {
                $('.' + $el.attr('id') + '-timepicker').css('width', $el.closest('.time-field').width());
            });
        });


        $('#pickupTimePicker', $targetForm)
            .on('click', function () {
                showPickupTimepicker($targetForm);
            })
            .on('changeTime', function () {
                if ($('#pickupTimePicker', $targetForm).val() == "") {
                    $targetForm.data('auto-trigger', '0');
                } else {
                    $('#pickupTimePicker', $targetForm).parents('.time-field:first').addClass('has-value');
                    if ($targetForm.data('auto-trigger') == '1') {
                        setTimeout(function () {
                            dropoffDatePicker.show();
                        }, 500);
                    }
                }
                formReadyCheck($targetForm);
            });

        $('#dropoffTimePicker', $targetForm)
            .on('click', function () {
                showDropoffTimepicker($targetForm);
            })
            .on('changeTime', function () {
                $('#dropoffTimePicker', $targetForm).parents('.time-field:first').addClass('has-value');
                formReadyCheck($targetForm);
            });



        // Auto trigger main form
        if($targetForm.hasClass('main')) {
            $('#pickupStation', $targetForm).on("change", function (e) {
                if ($targetForm.data('auto-trigger') == '1') {
                    $('#dropoffStation', $targetForm).val($(this).val()).trigger("change");
                    if ($('#pickupDatePicker', $targetForm).val() == '')
                        pickupDatePicker.show();
                }
            });

            $('#pickupDatePicker', $targetForm).each(function () {
                if ($('#pickupStation', $targetForm).val() == "") {
                    $('#pickupDatePicker', $targetForm).prop('disabled', true);
                    $('#pickupTimePicker', $targetForm).prop('disabled', true);
                }
                //if($('#pickupTimePicker').val() == "")
                //    $('#pickupTimePicker').prop('disabled', true);
            });

            $('#dropoffDatePicker', $targetForm).each(function () {
                if ($('#dropoffStation', $targetForm).val() == "") {
                    $('#dropoffDatePicker', $targetForm).prop('disabled', true);
                    $('#dropoffTimePicker', $targetForm).prop('disabled', true);
                }
                //if($('#dropoffTimePicker').val() == "")
                //    $('#dropoffTimePicker').prop('disabled', true);
            });
        }

    });

});

/* Deals with ajax added extras to the summary mini slider */
function refreshExtrasSummary(extraID, data) {
    data = data || {};
    if (data.hasOwnProperty('activeExtras')) {
        var activeSelector = '';
        $.each(data.activeExtras, function (extraID, extraData) {
            activeSelector += activeSelector ? ',' + '#extra-sb-item-' + extraID : '#extra-sb-item-' + extraID;
        });
        $('.extra-sb-item').addClass('hidden');
        $(activeSelector).removeClass('hidden');
    }

    if (data.hasOwnProperty('lockedExtras')) {
        var inactiveSelector = '';
        $.each(data.lockedExtras, function (key, extraId) {
            inactiveSelector += inactiveSelector ? ',' + '#extra-' + extraId : '#extra-' + extraId;
        });
        $('.extra-item').removeClass('hidden');
        $(inactiveSelector).addClass('hidden');
    }

    var $targetElem = $('#extra-' + extraID + ' > .wrapper'),
        $targetSidebarElem = $('#extra-sb-item-' + extraID);

    if ($targetElem.data('extra-enabled') == true) {
        var price = $targetElem.data('extra-price');
        var quantity = $targetElem.data('extra-quant');
        $targetSidebarElem.each(function () {
            $('.price-value', $(this)).html(price);
            $('.quant', $(this)).html(quantity);
            $(this).removeClass('hidden');
        });
    } else {
        $targetSidebarElem.addClass('hidden');
    }

    setTimeout(function () {
        $(window).resize();
        console.debug("resized");
    }, 200);
}